"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_DROPDOWN_LIST_ITEMS = exports.DROPDOWN_DEFAULT_TITLE = void 0;
exports.DROPDOWN_DEFAULT_TITLE = 'Select';
exports.MAX_DROPDOWN_LIST_ITEMS = 10;